import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const SERVICES = [
  "House Maid (Full-time & Part-time)",
  "Cook",
  "Baby Care / Babysitter",
  "Elder Care / Caretaker",
  "Patient Care",
  "Japa Maid (Newborn & Mother Care)",
  "House Cleaning Staff",
  "Driver",
  "Watchman",
  "Office Boy / Office Staff",
];

export const CONTACT = {
  phone: "9309451659",
  phoneIntl: "919309451659",
  phoneAlt: "8788136731",
  phoneAltIntl: "918788136731",
  email: "quickmaidservices.india@gmail.com",
  address:
    "1st Floor, Gharkul Apartment, Lane No. 4, Kavade Nagar, Pimple Gurav, Pune – 411061",
  hours: "Monday – Saturday · 9:00 AM – 6:00 PM",
};
